import React from "react";
import { NavLink } from "react-router-dom";
import { 
  FiBarChart2, 
  FiUsers, 
  FiLayers, 
  FiMapPin, 
  FiClipboard, 
  FiSettings, 
  FiLogOut,
  FiSearch 
} from "react-icons/fi";
import logo from "../assets/images/achal_logo.png";

const AdminSidebar = () => {
  //  SARE LINKS INTEGRATED HAIN
  const menu = [
    { name: "Terminal Overview", icon: <FiBarChart2 />, path: "/admin/dashboard" },
    { name: "Concern Person Management", icon: <FiUsers />, path: "/admin/hods" },
    { name: "User Directory", icon: <FiUsers />, path: "/admin/users" },
    { name: "Categories Hub", icon: <FiLayers />, path: "/admin/categories" },
    { name: "Ticket Lookup", icon: <FiSearch />, path: "/admin/ticket-lookup" },
    { name: "Location & QR", icon: <FiMapPin />, path: "/admin/locations" },
    { name: "Global Tickets", icon: <FiClipboard />, path: "/admin/tickets" },
    { name: "System Settings", icon: <FiSettings />, path: "/admin/settings" },
  ];

  const handleLogout = () => {
    if (window.confirm("Are you sure you want to sign out?")) {
      localStorage.clear();
      window.location.href = "/";
    }
  };

  return (
    <div style={styles.sidebar}>
      {/* 🏛️ PREMIUM LOGO SECTION */}
      <div style={styles.logoSection}>
        <img 
          src={logo} 
          alt="Achal Jewels" 
          style={styles.mainLogo} 
        />
        <div style={styles.logoDivider}></div>
        <p style={styles.subLogo}>Admin Terminal</p>
      </div>

      {/* NAVIGATION MENU */}
      <div style={styles.menu}>
        {menu.map((item, index) => (
          <NavLink
            key={index}
            to={item.path}
            style={({ isActive }) => ({
              ...styles.item,
              ...(isActive ? styles.active : styles.nonActive),
            })}
          >
            {({ isActive }) => (
              <>
                <span style={{ ...styles.icon, color: isActive ? "#000" : "#D4AF37" }}>
                  {item.icon}
                </span>
                <span>{item.name}</span>
              </>
            )}
          </NavLink>
        ))}
      </div>

      {/* LOGOUT SECTION */}
      <div style={styles.bottomSection}>
        <div style={styles.logoutBtn} onClick={handleLogout}>
          <FiLogOut style={styles.icon} />
          <span>Secure Sign Out</span>
        </div>
      </div>
    </div>
  );
};

const styles = {
  sidebar: {
    width: "280px",
    height: "100vh",
    background: "#FFFFFF",
    padding: "40px 20px",
    position: "fixed",
    display: "flex",
    flexDirection: "column",
    boxShadow: "10px 0 40px rgba(0,0,0,0.02)",
    zIndex: 100,
    top: 0,
    left: 0,
    boxSizing: "border-box",
  },
  logoSection: {
    marginBottom: "50px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    flexShrink: 0,
  },
  mainLogo: {
    height: "75px", 
    width: "auto",
    objectFit: "contain",
  },
  logoDivider: {
    width: "40px",
    height: "2px",
    background: "#D4AF37",
    margin: "15px 0 10px 0",
    borderRadius: "2px",
    opacity: 0.6
  },
  subLogo: { 
    fontSize: "10px", 
    color: "#94A3B8", 
    fontWeight: "800", 
    textTransform: "uppercase", 
    letterSpacing: "3px"
  },
  menu: { 
    display: "flex", 
    flexDirection: "column", 
    gap: "8px", 
    flex: 1,
    overflowY: "auto",
    paddingRight: "5px"
  },
  item: { 
    display: "flex", 
    alignItems: "center", 
    gap: "15px", 
    padding: "15px 20px", 
    borderRadius: "18px", 
    cursor: "pointer", 
    transition: "0.4s cubic-bezier(0.4, 0, 0.2, 1)",
    fontSize: "14px",
    fontWeight: "600",
    textDecoration: "none",
  },
  active: { 
    background: "#D4AF37", 
    color: "#000", 
    boxShadow: "0 10px 20px rgba(212, 175, 55, 0.25)",
    transform: "translateX(5px)"
  },
  nonActive: { 
    color: "#64748B",
    background: "transparent",
  },
  icon: { fontSize: "20px" },
  bottomSection: {
    marginTop: "auto",
    paddingTop: "25px",
    borderTop: "1px solid #F1F5F9",
  },
  logoutBtn: {
    display: "flex",
    alignItems: "center",
    gap: "15px",
    padding: "16px 20px",
    borderRadius: "18px",
    cursor: "pointer",
    color: "#EF4444", 
    background: "#FFF1F2", 
    transition: "0.3s",
    fontWeight: "700",
    fontSize: "13px"
  }
};

export default AdminSidebar;